import React, { FC } from 'react';
import { Cell, Divider, Layout, Text } from '@wix/design-system';
import css from '../TemplatePage.scss';
import { CollapsibleTextBox } from '../../UtilityComponents/CollapsibleTextBox';
import { useSingleTemplateData } from '../../../hooks/useSingleTemplateData';
import { DataHooks } from '../../../constants/dataHooks';
import ReactMarkdown from 'react-markdown';
import { getMarkDownRenderers } from '../../../utils/Markdowns/getMarkDownRenderers';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

export const Instructions: FC = () => {
  const { template } = useSingleTemplateData();
  const deploymentText = template?.deploymentInstructions;
  const renderers = React.useMemo(getMarkDownRenderers, []);

  if (!deploymentText) {
    return null;
  }
  return (
    <>
      <div className={css.divider}>
        <Divider skin="light" />
      </div>
      <div
        key={template.id}
        data-hook={DataHooks.InstructionsWrapper}
        className={css.deploymentWrapper}
      >
        <Layout>
          <Cell span={7}>
            <CollapsibleTextBox templateId={template.id}>
              <Text
                listStyle="circle"
                dataHook={DataHooks.InstructionsText}
                className={css.instructionsText}
              >
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw, remarkGfm]}
                  components={renderers}
                >
                  {deploymentText}
                </ReactMarkdown>
              </Text>
            </CollapsibleTextBox>
          </Cell>
        </Layout>
      </div>
    </>
  );
};
